<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>

<wl-card [heading]="heading" [subheading1]="subHeadingOne" [subheading2]="subHeadingTwo">
  <form [formGroup]="sofForm" class="sofContainer">

    <mat-card-actions class="sofChildContainer m-0 w-full">

      <!-- District -->
      <div class="select-container">
        <wl-autocomplete
          placeholder="Select District"
          [options]="districts"
          (selected)="selectDistrict($event)">
        </wl-autocomplete>
      </div>

      <!-- Season Radio -->
      <div class="radio-container" formGroupName="seasonGroup">
        <label *ngFor="let option of ['Summer', 'Kharif', 'Rabi']">
          <input type="radio"
                 formControlName="cropType"
                 [value]="option"
                 (change)="onCropTypeChange()" />
          {{ option }}
        </label>
      </div>

      <!-- Crop Select -->
      <!-- <div class="select-container">
        <mat-select placeholder="Select Crop"
                    class="w-full"
                    formControlName="selectedCrop"
                    (selectionChange)="selectCrop()"
                    [disabled]="!sofForm.get('seasonGroup.cropType').value">
          <mat-option *ngFor="let crop of crops" [value]="crop">{{ crop.crop_name }}</mat-option>
        </mat-select>
      </div> -->

      <div class="select-container">
        <wl-autocomplete class="w-full"
          placeholder="Select Crop"
          [options]="crops"
          (selected)="selectCrop()"  formControlName="selectedCrop" [disabled]="!sofForm.get('seasonGroup.cropType').value">
        </wl-autocomplete>
      </div>

      <!-- Original SOF Amount -->
      <div class="input-container">
        <mat-form-field class="w-full">
          <input matInput type="number"
                 placeholder="SOF Amount"
                 formControlName="originalSofAmount"
                 readonly>
        </mat-form-field>
      </div>

      <!-- Additional SOF -->
      <div class="input-container">
        <mat-form-field class="w-full"
                        [ngClass]="{'mat-input-invalid': sofForm.get('additionalSof').invalid && sofForm.get('additionalSof').touched}">
          <input matInput type="number"
                 placeholder="Additional SOF (In Percentage)"
                 formControlName="additionalSof"
                 (input)="onAdditionalSofChange(); sofForm.get('additionalSof').markAsTouched();"
                 min="0"
                 [max]="maxAllowedAdditionalSof"
                 (keypress)="($event && ['-', '+', '.'].includes($event.key)) ? $event.preventDefault() : null">
        </mat-form-field>
        <mat-error *ngIf="sofForm.get('additionalSof').invalid && sofForm.get('additionalSof').touched">
          <span *ngIf="maxAllowedAdditionalSof > 0">Additional SOF {{100 - maxAllowedAdditionalSof}} is already provided. Please enter a valid percentage between <strong>1 and {{maxAllowedAdditionalSof}}</strong>.</span>
        <span *ngIf="maxAllowedAdditionalSof == 0">The SOF has already been increased to 100%.</span>
        </mat-error>
      </div>

      <!-- Revised SOF -->
      <div class="input-container">
        <mat-form-field class="w-full">
          <input matInput type="number"
                 placeholder="Revised SOF Amount"
                 formControlName="revisedSof"
                 readonly>
        </mat-form-field>
      </div>
    </mat-card-actions>

    <!-- Save -->
    <button class="mr-2rem mybutton"
           
            [disabled]="sofForm.invalid || sofForm.get('additionalSof').value > maxAllowedAdditionalSof"
            (click)="submitForm()">
      Save
    </button>
  </form>
</wl-card>
